import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	environmentTypeTitle: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.legend.environment-type-title',
		defaultMessage: 'Environment type',
		description: 'The title of the graph legend showing deployment environment types',
	},
	weeklyDeploymentTitle: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.legend.weekly-deployment-title',
		defaultMessage: 'Week Deployments',
		description:
			'The column title of the graph legend that shows the number of deployments on the selected week',
	},
	unmappedTooltip: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.legend.unmapped-tooltip',
		defaultMessage:
			'Unmapped or missing environments. Configure your deployment tool to map your deployment to the environment type.',
		description:
			'The tooltip that is displayed when uses mouse-hovers on the tooltip of unmapped environment legend. If we find unmapped deployment environment, we want to encourage customer to map their deployment environment correctly in their deployment tool.',
	},
});
